import { observer } from 'mobx-react-lite';
import WreckerPrice from './WreckerPrice';
import CancellationFee from './CancellationFee';

export default observer(function OtherPriceList() {
    return (
        <>
            <WreckerPrice />
            <CancellationFee />
        </>
    );
});
